exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 1